import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { useGameStore } from '../store/gameStore'
import { db } from '../lib/supabase'

export function useGardenActions() {
  const user = useAuthStore((state) => state.user)
  const plants = useGameStore((state) => state.plants)
  const selectedBackground = useGameStore((state) => state.selectedBackground)
  const clearGardenAfterPublish = useGameStore((state) => state.clearGardenAfterPublish)
  const navigate = useNavigate()
  
  const [showPublishModal, setShowPublishModal] = useState(false)
  const [showDestroyModal, setShowDestroyModal] = useState(false)
  const [publishError, setPublishError] = useState(null)
  const [isPublishing, setIsPublishing] = useState(false)
  const [plantToDestroy, setPlantToDestroy] = useState(null)
  const [publishSnapshot, setPublishSnapshot] = useState(null)

  const handleOpenPublishModal = (snapshot = null) => {
    setShowPublishModal(true)
    setPublishError(null)
    if (snapshot) {
      setPublishSnapshot(snapshot)
    }
    if (!user) {
      setPublishError('Vous devez être connecté pour publier votre jardin.')
    }
  }

  const handlePublishPlant = async () => {
    if (!user) return

    // Vérifier qu'il y a au moins une plante mature dans le jardin
    const hasMaturePlant = plants.some((plant) => {
      if (!plant || !plant.config) return false
      const totalClicks = plant.config.clicksPerStage * plant.config.stages
      return (plant.progress || 0) >= totalClicks
    })

    if (!hasMaturePlant) {
      setPublishError('Vous devez avoir au moins une plante mature pour publier votre jardin.')
      return
    }

    setIsPublishing(true)
    setPublishError(null)

    try {
      const gardenSnapshot = {
        plants,
        background: selectedBackground,
        createdAt: Date.now(),
        snapshot: publishSnapshot || null,
      }

      await db.publishPlant(user.id, gardenSnapshot)

      clearGardenAfterPublish()
      setShowPublishModal(false)
      setPublishSnapshot(null)
      navigate('/community', { state: { publishSuccess: true, highlightMine: true } })
    } catch (error) {
      console.error('Error publishing garden:', error)
      setPublishError(error.message || 'Erreur lors de la publication')
    } finally {
      setIsPublishing(false)
    }
  }

  const handleOpenDestroyModal = (plant) => {
    setPlantToDestroy(plant)
    setShowDestroyModal(true)
  }

  const handleDestroyPlant = (destroyPlantById) => {
    if (plantToDestroy && destroyPlantById) {
      destroyPlantById(plantToDestroy.id)
      setShowDestroyModal(false)
      setPlantToDestroy(null)
    }
  }

  return {
    // State
    showPublishModal,
    showDestroyModal,
    publishError,
    isPublishing,
    plantToDestroy,
    publishSnapshot,
    
    // Actions
    handleOpenPublishModal,
    handlePublishPlant,
    handleOpenDestroyModal,
    handleDestroyPlant,
    
    // Setters
    setShowPublishModal,
    setShowDestroyModal,
    setPublishSnapshot,
  }
}
